export default {
  BP_DESKTOP: 1024,
  BP_LAPTOP: 768,
  BP_TABLET: 600,
};

export const BP_DESKTOP = 1024;
export const BP_LAPTOP = 768;
export const BP_TABLET = 600;
